import React, { useState } from 'react';
import './navigationItems.css';
import NavigationItem from './navigationItem/navigationItem';
import Aux from '../../../hoc/aux/aux';
import history from '../../../utils/history';
import * as actions from '../../../store/actions/index';
import { connect } from 'react-redux';
// import imageDefault from '../../../assets/images/okgo.png';

const NavigationItems = ( props ) => {
    const [logoutState, setLogout] = useState(false);
    let signoutView = null;
    const logout = () => {
        props.onRefreshCart();
        props.onRemoveAuth();
        props.clicked();
        localStorage.clear();
        if (logoutState) {}
        setLogout(true);
        history.push('/login');
    }

    if(props.isLoggedIn) {
        signoutView = (
            <ul className="NavigationItemsBottom">
                <div className="SidebarMenu">
                    <li className="NavigationItem">
                        <div className="div-a" tag="a" onClick={logout}>Logout</div>
                    </li>
                </div>
            </ul>
        )
    }
    
    return (
        <Aux>
            <ul className="NavigationItems">
                <NavigationItem clicked={props.clicked} link="/" exact>Home</NavigationItem>
                {/* <NavigationItem clicked={props.clicked} link="/cart">My Cart</NavigationItem>  */}
            </ul>
            {signoutView}
        </Aux>
)};

const mapStateToProps = state => {
    return {
        isLoggedIn: state.user.isLoggedIn
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onRemoveAuth: () => dispatch(actions.authRemove()),
        onRefreshCart: () => dispatch(actions.clearCart())
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)( NavigationItems );


